import React from "react";
import { useQuery } from "react-query";
import { getRegistrationFormInfo } from "./gateway";
import { AxiosError } from "axios";
import { enqueueSnackbar } from "notistack";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export default function useGetRegistrationFormInfo(bid: number) {
  const navigate = useNavigate();

  return useQuery({
    queryFn: () => getRegistrationFormInfo(bid),
    queryKey: ["registrationForm", bid],
    onError: (error: AxiosError<string>) => {
      enqueueSnackbar(error?.response?.data || t("Σφάλμα Προσπαθήστε Ξανά"), {
        variant: "error",
      });
      navigate("/welcome/ggpsIntro");
    },
  });
}
